export const splitDaysInWorkAndWeekend = (days, date) => {
  let workdays = 0;
  let weekendDays = 0;
  const startDate = new Date(date + 'T00:00:00');

  if (isNaN(startDate.getTime())) {
    return [0,0];
  }

  for (let i = 0; i < days; i += 1) {
    const d = new Date(startDate);
    d.setDate(startDate.getDate() + i);
    const day = d.getDay();
    if (day >= 1 && day <= 5) {
      workdays += 1;
    } else {
      weekendDays += 1;
    }
  }

  console.log('splitDaysInWorkAndWeekend', workdays, weekendDays);

  return [workdays, weekendDays];
};
